// Use curated system/display stacks so editor previews and rendered websites match
// without requiring external font downloads.
export const FONT_FAMILY_STACKS = {
  sans: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  serif: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  Didot: 'Didot, "Bodoni MT", "Bodoni 72", "Times New Roman", serif',
  Bodoni: '"Bodoni 72", "Bodoni MT", Didot, "Times New Roman", serif',
  Copperplate: '"Copperplate", "Copperplate Gothic Light", "Copperplate Gothic Bold", fantasy',
  Rockwell: 'Rockwell, "Rockwell Nova", "Roboto Slab", "Courier New", serif',
  Avenir_Next: '"Avenir Next", Avenir, "Segoe UI", Helvetica, Arial, sans-serif',
  Futura: 'Futura, "Avenir Next", "Century Gothic", Arial, sans-serif',
  Gill_Sans: '"Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif',
  Hoefler_Text: '"Hoefler Text", Baskerville, "Baskerville Old Face", "Times New Roman", serif',
  American_Typewriter: '"American Typewriter", Cambria, Georgia, serif',
  Cochin: 'Cochin, "Hoefler Text", Baskerville, "Times New Roman", serif',
  Big_Caslon: '"Big Caslon", Baskerville, "Times New Roman", serif',
  Brush_Script_MT: '"Brush Script MT", "Segoe Script", "Lucida Handwriting", cursive',
  Snell_Roundhand: '"Snell Roundhand", "Brush Script MT", "Lucida Handwriting", cursive',
  Bradley_Hand: '"Bradley Hand", "Segoe Print", "Comic Sans MS", cursive',
  Marker_Felt: '"Marker Felt", "Bradley Hand", "Segoe Print", cursive',
  Chalkduster: 'Chalkduster, "Marker Felt", "Bradley Hand", cursive',
  Papyrus: 'Papyrus, "Copperplate", fantasy',
  Herculanum: 'Herculanum, Papyrus, fantasy',
  Trattatello: 'Trattatello, Papyrus, fantasy',
  Arial: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  Helvetica: 'Helvetica, "Helvetica Neue", Arial, sans-serif',
  Times_New_Roman: '"Times New Roman", Times, serif',
  Verdana: 'Verdana, Geneva, Tahoma, sans-serif',
  Georgia: 'Georgia, "Times New Roman", Times, serif',
  Tahoma: 'Tahoma, Geneva, Verdana, sans-serif',
  Trebuchet_MS: '"Trebuchet MS", Tahoma, Verdana, sans-serif',
  Arial_Black: '"Arial Black", Gadget, sans-serif',
  Impact: 'Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif',
  Comic_Sans_MS: '"Comic Sans MS", "Comic Sans", cursive',
  Courier: 'Courier, "Courier New", monospace',
  Courier_New: '"Courier New", Courier, monospace',
  Garamond: 'Garamond, Baskerville, "Baskerville Old Face", "Hoefler Text", "Times New Roman", serif',
  Palatino: 'Palatino, "Palatino Linotype", "Book Antiqua", serif',
  Century_Gothic: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif',
  Calibri: 'Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
  Lucida_Sans: '"Lucida Sans", "Lucida Sans Unicode", "Lucida Grande", Geneva, Verdana, sans-serif',
  Lucida_Console: '"Lucida Console", Monaco, monospace',
  Geneva: 'Geneva, Tahoma, Verdana, sans-serif',
  Candara: 'Candara, Calibri, Segoe, "Segoe UI", Optima, Arial, sans-serif',
  Segoe_UI: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  Optima: 'Optima, Segoe, "Segoe UI", Candara, Calibri, Arial, sans-serif',
  Franklin_Gothic: '"Franklin Gothic Medium", "Franklin Gothic", "ITC Franklin Gothic", Arial, sans-serif',
  Baskerville: 'Baskerville, "Baskerville Old Face", "Hoefler Text", Garamond, "Times New Roman", serif',
  // Modern sans-serif
  Roboto: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
  Open_Sans: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  Lato: 'Lato, "Helvetica Neue", Helvetica, Arial, sans-serif',
  Montserrat: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif',
  Poppins: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif',
  Inter: 'Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  Raleway: 'Raleway, "Century Gothic", CenturyGothic, AppleGothic, sans-serif',
  Oswald: 'Oswald, "Arial Narrow", Arial, sans-serif',
  Nunito: 'Nunito, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  Source_Sans_3: '"Source Sans 3", "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif',
  Work_Sans: '"Work Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  DM_Sans: '"DM Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  Quicksand: 'Quicksand, "Comfortaa", "Nunito", "Segoe UI", sans-serif',
  Josefin_Sans: '"Josefin Sans", "Century Gothic", CenturyGothic, AppleGothic, sans-serif',
  Cabin: 'Cabin, "Gill Sans", "Gill Sans MT", Calibri, sans-serif',
  Karla: 'Karla, "Helvetica Neue", Helvetica, Arial, sans-serif',
  Barlow: 'Barlow, "Helvetica Neue", Helvetica, Arial, sans-serif',
  Mulish: 'Mulish, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  Manrope: 'Manrope, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  // Modern serif
  Merriweather: 'Merriweather, Georgia, "Times New Roman", Times, serif',
  Playfair_Display: '"Playfair Display", Didot, "Bodoni MT", "Times New Roman", serif',
  Lora: 'Lora, Georgia, "Times New Roman", Times, serif',
  Libre_Baskerville: '"Libre Baskerville", Baskerville, "Baskerville Old Face", Georgia, serif',
  Crimson_Text: '"Crimson Text", Garamond, "Times New Roman", Times, serif',
  EB_Garamond: '"EB Garamond", Garamond, "Times New Roman", Times, serif',
  Source_Serif_4: '"Source Serif 4", "Source Serif Pro", Georgia, "Times New Roman", serif',
  Cormorant: 'Cormorant, Garamond, "Times New Roman", Times, serif',
  // System serif additions
  Cambria: 'Cambria, Georgia, "Times New Roman", Times, serif',
  Constantia: 'Constantia, "Palatino Linotype", Palatino, Georgia, serif',
  Book_Antiqua: '"Book Antiqua", "Palatino Linotype", Palatino, Georgia, serif',
  Charter: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
  // System sans-serif addition
  Corbel: 'Corbel, "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Verdana, sans-serif',
  // Display / heading
  Bebas_Neue: '"Bebas Neue", "Arial Narrow", Arial, sans-serif',
  Abril_Fatface: '"Abril Fatface", Didot, "Bodoni MT", "Times New Roman", serif',
  Anton: 'Anton, Impact, "Arial Black", sans-serif',
  // Script / handwriting
  Dancing_Script: '"Dancing Script", "Brush Script MT", "Segoe Script", cursive',
  Zapfino: 'Zapfino, "Apple Chancery", "Segoe Script", cursive',
  Apple_Chancery: '"Apple Chancery", Zapfino, "Segoe Script", cursive',
  Segoe_Script: '"Segoe Script", "Apple Chancery", "Lucida Handwriting", cursive',
  // Monospace additions
  Menlo: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  Consolas: 'Consolas, Menlo, Monaco, "Liberation Mono", "Courier New", monospace',
  Monaco: 'Monaco, Menlo, Consolas, "Liberation Mono", "Courier New", monospace',
  Source_Code_Pro: '"Source Code Pro", Menlo, Monaco, Consolas, "Courier New", monospace',
  Fira_Code: '"Fira Code", "Fira Mono", Menlo, Monaco, Consolas, monospace',
  JetBrains_Mono: '"JetBrains Mono", "Fira Code", Menlo, Monaco, Consolas, monospace',
  IBM_Plex_Mono: '"IBM Plex Mono", Menlo, Monaco, Consolas, "Courier New", monospace',
};

const GENERIC_FONT_FAMILY_CLASSES = {
  sans: "font-sans",
  serif: "font-serif",
  mono: "font-mono",
};

const normalizeFontFamilyKey = (fontFamily) =>
  typeof fontFamily === "string" ? fontFamily.trim() : "";

export const FONT_FAMILY_KEYS = Object.keys(FONT_FAMILY_STACKS);

export function getFontFamilyClass(fontFamily) {
  const normalized = normalizeFontFamilyKey(fontFamily);
  if (!normalized) {
    return "font-sans";
  }
  return GENERIC_FONT_FAMILY_CLASSES[normalized] || "";
}

export function getFontFamilyStack(fontFamily) {
  const normalized = normalizeFontFamilyKey(fontFamily);
  if (!normalized) {
    return null;
  }
  return FONT_FAMILY_STACKS[normalized] || normalized;
}

export function getFontFamilyPreviewStack(fontFamily) {
  return getFontFamilyStack(fontFamily) || FONT_FAMILY_STACKS.sans;
}

export function getFontFamilyStyle(fontFamily) {
  const normalized = normalizeFontFamilyKey(fontFamily);
  if (!normalized || GENERIC_FONT_FAMILY_CLASSES[normalized]) {
    return {};
  }

  const stack = getFontFamilyStack(normalized);
  return stack ? { fontFamily: stack } : {};
}
